import { CREATE_ACCOUNT_SUCCESS, CREATE_ACCOUNT_ERROR, CREATE_ACCOUNT_REQUEST } from "../Actions/AccountCreateActions";


const initialState = {
    submitting: false,
    error: ''
}

export const createAccount = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                error: '',
                submitting: false
            }
        case CREATE_ACCOUNT_ERROR:
            return {
                ...state,
                error: action.payload,
                submitting: false
            }
        case CREATE_ACCOUNT_REQUEST:
            return {
                ...state,
                email: action.payload,
                submitting: true
            }
        default:
            return state;
    }
}